import React from 'react';
import { Smartphone, Calculator, FileSignature, Mail } from 'lucide-react';
import { CONTACT_CONFIG } from '../config/contact';
export function Process() {
  const steps = [{
    icon: <Smartphone className="w-8 h-8 text-blue-700" data-id="element-97" />,
    title: '1. Send your document',
    desc: 'Take a clear photo or scan your document and send it directly via WhatsApp.'
  }, {
    icon: <Calculator className="w-8 h-8 text-blue-700" data-id="element-98" />,
    title: '2. Get a quote',
    desc: 'Within minutes we review your document and give you the exact price, no obligations.'
  }, {
    icon: <FileSignature className="w-8 h-8 text-blue-700" data-id="element-99" />,
    title: '3. We translate and certify',
    desc: 'Our experts translate and add the required official certification.'
  }, {
    icon: <Mail className="w-8 h-8 text-blue-700" data-id="element-100" />,
    title: `4. Receive it in ${CONTACT_CONFIG.DELIVERY_TIME}`,
    desc: 'We email you the certified PDF, ready to print or submit to USCIS.'
  }];
  return <section id="proceso" className="py-20 bg-blue-900 text-white scroll-mt-24" data-id="element-101">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-102">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-103">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-104">
            A fast, hassle-free process
          </h2>
          <p className="text-blue-200 text-lg" data-id="element-105">
            We know you're in a hurry. We designed our process so you never have
            to leave home.
          </p>
        </div>

        <div className="grid md:grid-cols-4 gap-8 relative" data-id="element-106">
          {/* Connector line for desktop */}
          <div className="hidden md:block absolute top-12 left-[10%] right-[10%] h-0.5 bg-blue-800 z-0" data-id="element-107"></div>

          {steps.map((step, index) => <div key={index} className="relative z-10 flex flex-col items-center text-center" data-id="element-108">
              <div className="w-24 h-24 bg-blue-800 rounded-full flex items-center justify-center border-4 border-blue-900 mb-6 shadow-xl" data-id="element-109">
                <div className="bg-white w-16 h-16 rounded-full flex items-center justify-center" data-id="element-110">
                  {step.icon}
                </div>
              </div>
              <h3 className="text-xl font-bold mb-3" data-id="element-111">{step.title}</h3>
              <p className="text-blue-200 text-sm leading-relaxed" data-id="element-112">
                {step.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}